
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 17 17","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_0_3)"}},[_c('path',{attrs:{"d":"M8.5 16.5A8 8 0 1 0 8.5.499a8 8 0 0 0 0 16.001Z","fill":"#6D00CC"}}),_c('path',{attrs:{"d":"M11.17 5.281a.225.225 0 0 0-.225.224v6.006a.225.225 0 0 0 .224.225h1.627a.224.224 0 0 0 .225-.225V5.505a.223.223 0 0 0-.224-.224h-1.628.001Zm-4.773.08L3.7 10.725a.225.225 0 0 0 .1.302l1.454.73a.225.225 0 0 0 .301-.1l2.697-5.366a.224.224 0 0 0-.1-.301L6.7 5.261a.225.225 0 0 0-.303.1Zm2.269.018-1.154 5.85a.225.225 0 0 0 .176.263l1.594.322a.226.226 0 0 0 .232-.095.226.226 0 0 0 .033-.082l1.154-5.849a.225.225 0 0 0-.176-.264l-1.594-.322a.225.225 0 0 0-.265.177Z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{staticClass:"i-clip0_0_3"},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h17v17H0z"}})])])])
          )
        }
      }
    